<template>
    <div class="animated fadeIn" v-if="satisfiedDependencies">
        <b-row class="py-2">
            <b-card header="Nuevo Rol" class="w-100">
                <role-form
                    :permissions="permissions"
                    :initialPermissions="[]"
                    :initialName="null"
                    :initialDescription="null"
                    @emit-role-form="add($event)">
                    <div class="w-100 d-flex justify-content-between align-items-center m-0 px-3">
                        <div>
                            &nbsp
                        </div>
                        <div>
                            <button
                                type="submit"
                                class="btn btn-brand btn-primary btn-lg"
                                v-if="mixinCheckPermission('ROLE_ADD')">
                                Guardar
                            </button>
                        </div>
                    </div>
                </role-form>
            </b-card>
        </b-row>
    </div>
</template>

<script>
    import RoleForm from '@/components/roles/RoleForm';
    import {getPermissions} from '@/api/permission-api';
    import {createRole} from '@/api/role-api';

    export default {
        name: "add-role",
        components: {
            RoleForm
        },
        mounted() {
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.getPermissions();
        },
        data: function () {
            return {
                topmenu: [
                    {
                        name: 'Volver',
                        path: '/admin/roles/list',
                        brand: 'fa fa-arrow-left'
                    },
                ],
                permissions: null
            };
        },
        computed: {
            satisfiedDependencies() {
                return !!this.permissions;
            }
        },
        methods: {
            async getPermissions() {
                this.$_loadingMixin_showLoading();
                await getPermissions()
                    .then((permissions) => {
                        this.permissions = permissions;
                    });
                this.$_loadingMixin_hideLoading();
            },
            add(role) {
                this.$_loadingMixin_showLoading();
                createRole(role)
                    .then(() => {
                        this.$_notificationMixin_success('Operación Completada', 'Realizado con éxito');
                        this.$_loadingMixin_hideLoading();
                        this.$router.push({path: '/admin/roles/list'});
                    })
                    .catch(() => {
                        this.$_notificationMixin_error('Operación denegada', 'Algo salió mal');
                        this.$_loadingMixin_hideLoading();
                    });
            }
        }
    }
</script>

<style scoped>

</style>